module.exports = __webpack_public_path__ + "static/media/default_image.f065b10c.png";